// extracted by mini-css-extract-plugin
export default {"container":"main_container__1beiN","inner":"main_inner__Ntdrd","cookies":"main_cookies__37BQq","cookieIcon":"main_cookieIcon__q2UiH"};